export default function (Component) {
       if(!Component.options.wxsCallMethods){
         Component.options.wxsCallMethods = []
       }
       Component.options.wxsCallMethods.push('_handleRefresherTouchstart')
Component.options.wxsCallMethods.push('_handleScrollViewDisableBounce')
Component.options.wxsCallMethods.push('_handleWxsPullingDown')
Component.options.wxsCallMethods.push('_handleRefresherTouchmove')
Component.options.wxsCallMethods.push('_handleRefresherTouchend')
Component.options.wxsCallMethods.push('_handlePropUpdate')
Component.options.wxsCallMethods.push('_handleWxsPullingDownStatusChange')
     }